import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import HomePage from './pages/HomePage';
import QuienesSomos from './pages/QuienesSomos';
import Consultas from './pages/Consultas';
import LoginPage from './pages/LoginPage';
import PanelPrincipal from './pages/PanelPrincipal';
import Medidores from './pages/Medidores';
import Clientes from './pages/Clientes';
import Usuarios from './pages/Usuarios';
import Tarifas from './pages/Tarifas';
import Consumos from './pages/Consumos';
import Pagos from './pages/Pagos';
import Reportes from './pages/Reportes';
import PerfilUsuario from './pages/PerfilUsuario';
import RendicionCuentas from './pages/RendicionCuentas';
import ProtectedRoute from './pages/ProtectedRoute';
import './App.css';

const App = () => {
  return (
    <Router>
      <Routes>
        {/* Ruta principal */}
        <Route path="/" element={<HomePage />}>
          <Route path="/quienes-somos" element={<QuienesSomos />} />
          <Route path="/consultas" element={<Consultas />} />
          <Route path="/como-funciona" element={<div>Cómo funciona</div>} />
          <Route path="/login" element={<LoginPage />} />
        </Route>
        
        {/* Ruta para el Panel Principal */}
        <Route path="/panel" element={<PanelPrincipal />}>
          <Route path="medidores" element={<ProtectedRoute allowedRoles={['Administrador', 'Presidente', 'Tesorero']}><Medidores /></ProtectedRoute>} />
          <Route path="clientes" element={<ProtectedRoute allowedRoles={['Administrador', 'Presidente', 'Tesorero']}><Clientes /></ProtectedRoute>} />
          <Route path="usuarios" element={<ProtectedRoute allowedRoles={['Administrador', 'Presidente']}><Usuarios /></ProtectedRoute>} />
          <Route path="tarifas" element={<ProtectedRoute allowedRoles={['Administrador', 'Presidente']}><Tarifas /></ProtectedRoute>} />
          <Route path="consumos" element={<ProtectedRoute allowedRoles={['Administrador', 'Presidente', 'Consumidor', 'Tesorero']}><Consumos /></ProtectedRoute>} />
          <Route path="pagos" element={<ProtectedRoute allowedRoles={['Administrador', 'Tesorero','Externo']}><Pagos /></ProtectedRoute>} />
          <Route path="perfil-usuario" element={<ProtectedRoute allowedRoles={['Administrador', 'Presidente', 'Tesorero','Consumidor','Externo']}><PerfilUsuario /></ProtectedRoute>} />
          <Route path="reportes" element={<ProtectedRoute allowedRoles={['Administrador', 'Presidente','Consumidor','Tesorero','Externo']}><Reportes /></ProtectedRoute>} />
          <Route path="rendicioncuentas" element={<ProtectedRoute allowedRoles={['Administrador', 'Presidente','Consumidor','Tesorero','Externo']}><RendicionCuentas /></ProtectedRoute>} />
        
          {/* Ruta por defecto */}
          <Route path="*" element={<h2>Página no encontrada</h2>} />
          </Route>
      </Routes>
    </Router>
  );
};

export default App;
